module.exports = __webpack_public_path__ + "0744aa8727ae12726f55a7dfde2962d3.pdf";